import { render, staticRenderFns } from "./About.vue?vue&type=template&id=26d32ca7&scoped=true&"
import script from "./about.js?vue&type=script&lang=js&"
export * from "./about.js?vue&type=script&lang=js&"
import style0 from "./about.scss?vue&type=style&index=0&id=26d32ca7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d32ca7",
  null
  
)

export default component.exports